export const generateUserUuid = (): string =>
    '00000000-0000-0000-0000-000000000000'.replace(/0/g, function () {
        try {
            return (crypto.getRandomValues(new Uint8Array(1))[0] % 16).toString(16).toUpperCase()
        } catch (ignore) {
            return Math.round(Math.random() * 15)
                .toString(16)
                .toUpperCase() // NOSONAR: we tried our best before
        }
    })
